import { getRecord, saveRecord } from '@/services/localDb';
import { partnerTokenClaims, getPartnerRestaurantId } from '@/services/auth/partnerSessionStorage';

const DEVICE_KEY_PREFIX = 'ewu_tpv_device_key:';
const scope = () => getPartnerRestaurantId();
const storageKey = (deviceId, restaurantId) => `${DEVICE_KEY_PREFIX}${restaurantId ? restaurantId + ':' : ''}${deviceId}`;
function readLocal(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}
function legacyBelongsTo(restaurantId) {
  if (!partnerTokenClaims().restaurant_id) return true;
  try {
    const cached = JSON.parse(localStorage.getItem('ewu_tpv_partner_session_cache') || 'null');
    return cached?.id === partnerTokenClaims().id && String(cached?.restaurant_id || '') === restaurantId;
  } catch { return false; }
}
export async function getDeviceKey(deviceId) {
  if (!deviceId) return null;
  const restaurantId = scope();
  const key = storageKey(deviceId, restaurantId);
  const localKey = readLocal(key);
  if (localKey) return localKey;
  const record = await getRecord('devices', deviceId);
  let value = restaurantId ? record?.restaurant_device_keys?.[restaurantId] : record?.device_key;
  // Carry forward a known original credential without exposing it to another restaurant.
  if (restaurantId && !value && !Object.prototype.hasOwnProperty.call(record?.restaurant_device_keys || {}, restaurantId) && legacyBelongsTo(restaurantId)) {
    value = readLocal(storageKey(deviceId, '')) || record?.device_key;
  }
  if (value) { try { localStorage.setItem(key, value); } catch { /* IndexedDB fallback. */ } }
  return value || null;
}
export async function storeDeviceKey(deviceId, deviceKey) {
  if (!deviceId || !deviceKey) return false;
  const restaurantId = scope();
  try { localStorage.setItem(storageKey(deviceId, restaurantId), deviceKey); } catch { /* Persist below. */ }
  const record = await getRecord('devices', deviceId);
  await saveRecord('devices', {
    ...(record || { id: deviceId }),
    ...(restaurantId ? { restaurant_device_keys: { ...record?.restaurant_device_keys, [restaurantId]: deviceKey } } : {}),
    ...(!partnerTokenClaims().restaurant_id ? { device_key: deviceKey } : {}),
    updated_at: new Date().toISOString(),
  });
  return true;
}
export async function clearDeviceKey(deviceId) {
  if (!deviceId) return;
  const restaurantId = scope();
  try { localStorage.removeItem(storageKey(deviceId, restaurantId)); } catch { /* Optional storage. */ }
  const record = await getRecord('devices', deviceId);
  if (!record) return;
  const keys = { ...record.restaurant_device_keys };
  keys[restaurantId] = null;
  const legacy = !partnerTokenClaims().restaurant_id;
  if (legacy) { try { localStorage.removeItem(storageKey(deviceId, '')); } catch { /* Optional storage. */ } }
  await saveRecord('devices', { ...record,
    ...(restaurantId ? { restaurant_device_keys: keys } : {}),
    ...(legacy ? { device_key: null } : {}),
    updated_at: new Date().toISOString() });
}
